import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/item',
    // component: HomeView,
  },
  {
    path: '/item',
    name: 'item-index',
    component: () => import(/* webpackChunkName: "item" */ '../views/ItemIndex'),
  },
  {
    path: '/item/:id',
    name: 'item-detail',
    component: () => import(/* webpackChunkName: "item" */ '../views/ItemDetail'),
  },
  {
    path: '/monster',
    name: 'monster-index',
    component: () => import(/* webpackChunkName: "monster" */ '../views/MonsterIndex'),
  },
  {
    path: '/monster/:id',
    name: 'monster-detail',
    component: () => import(/* webpackChunkName: "monster" */ '../views/MonsterDetail'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "404" */ '../views/NotFound'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
    if (from.name === to.name) {
      return false;
    }
    return savedPosition || { x: 0, y: 0 };
  },
});

export default router;
